import React from 'react';

import ChosenTasksList from './ChosenTasksList';
import RightSidebarSearchForm from '../_earnMoneyCommon/RightSidebarSearchForm';
import ColumnsContent from '../../../../../components/Hocs/ColumnsContent';
import GroupsSearchCollector from '../../../../../components/Hocs/GroupsSearchNewCollector/GroupsSearchCollector';
import groupsSearchItem from '../../../../../components/Hocs/GroupsSearchNewCollector/GroupsSearchItem';

const GroupsSearchItem = groupsSearchItem(ChosenTasksList);
const Content = ColumnsContent(
  GroupsSearchCollector(props => (
    <GroupsSearchItem
      {...props}
      groupName="tasksListChosenTasks"
      listReduceName="tasksModule.lists.tasksListChosenTasks"
    />
  )),
  () => (
    <RightSidebarSearchForm listReduceName="tasksModule.lists.tasksListChosenTasks" />
  )
);

export default props => <Content {...props} />;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/EarnMoney/ChosenTasksList/index.js